<template>
  <div class="cat-card" :class="`cat-card--${tier.toLowerCase()}`">
    <div class="cat-card__tier">{{ tier }}</div>
    <div class="cat-card__name">{{ name }}</div>
    <div v-if="desc" class="cat-card__desc">{{ desc }}</div>
    <a
      class="cat-card__cta"
      :href="REGISTRATION_URL"
      target="_blank"
      rel="noopener"
    >
      Inscríbete <span aria-hidden="true">→</span>
    </a>
  </div>
</template>

<script setup>
// Molecule · Category card
//   Tier "PRO" → dark surface, "OPEN" → light surface. Orange tier eyebrow
//   over a display-type name, an optional description line, and an
//   "Inscríbete" CTA linking to the external registration platform.
//
//   <CategoryCard tier="PRO" name="Masculino Pro" desc="Parejas masculinas · pesos Pro" />
//   <CategoryCard tier="OPEN" name="Mixta Open" />
import { REGISTRATION_URL } from '@/registration'

defineProps({
  tier: {
    type: String,
    default: 'PRO',
    validator: (v) => ['PRO', 'OPEN'].includes(v),
  },
  name: { type: String, required: true },
  desc: { type: String, default: '' },
})
</script>

<style scoped lang="scss">
.cat-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 140px;
  padding: 24px 26px;
  background: #fff;
  border: 2px solid var(--hir-black);
  transition: all var(--dur-fast) var(--ease-out);
}

.cat-card:hover {
  box-shadow: 6px 6px 0 var(--hir-orange);
  transform: translate(-2px, -2px);
}

.cat-card--pro {
  background: var(--hir-black);
  color: var(--hir-white);
}

.cat-card__tier {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--hir-orange);
}

.cat-card__name {
  font-family: var(--font-display);
  /* Scales down on narrow screens so two columns keep fitting. */
  font-size: clamp(22px, 5vw, 36px);
  line-height: 1;
  letter-spacing: -0.005em;
  text-transform: uppercase;
}

.cat-card__desc {
  font-family: var(--font-body);
  font-size: clamp(14px, 5vw, 12px);
  line-height: 1.5;
  color: var(--fg-2);
}

.cat-card--pro .cat-card__desc {
  color: rgba(255, 255, 255, 0.7);
}

.cat-card__cta {
  margin-top: auto;
  padding-top: 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--hir-black);
  transition: gap var(--dur-fast) var(--ease-out),
    color var(--dur-fast) var(--ease-out);
}

.cat-card__cta span {
  transition: transform var(--dur-fast) var(--ease-out);
}

.cat-card__cta:hover {
  color: var(--hir-orange);
}

.cat-card__cta:hover span {
  transform: translateX(4px);
}

.cat-card--pro .cat-card__cta {
  color: #fff;
}

.cat-card--pro .cat-card__cta:hover {
  color: var(--hir-orange);
}
</style>
